import { module } from 'modujs'
import { createApp, ref, reactive, watch } from 'vue/dist/vue.esm-bundler.js'
import { VInputSelect } from '../vue/components'
import { MODAL_CONTENT_KEYS, VUE_SETTINGS } from '../config'

export default class extends module {
    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el

        // Vars
        this.DEFAULT_VALUE = this.getData('default')
    }

    init() {

        this.vueApp = createApp({
            ...VUE_SETTINGS,
            components: {
                VInputSelect,
            },
            setup: () => {
                console.log(this.DEFAULT_VALUE)

                // Reactive data
                const filter = reactive({
                    $model: this.DEFAULT_VALUE
                })
                const filterValue = ref(this.DEFAULT_VALUE)

                // Methods
                const openModal = id => {
                    this.call('open', { type: MODAL_CONTENT_KEYS.SHOW, id }, 'ModalContent')
                }

                // Watchers
                watch(filter, newFilter => {
                    console.log(filter, newFilter.$model)

                    if(newFilter.$model === filterValue.value) {
                        return
                    }

                    filterValue.value = newFilter.$model

                    const url = filterValue.value

                    this.call('goTo', { url }, 'Load')
                })

                return {
                    filter,
                    openModal,
                }
            }
        })
        this.vueApp.mount(this.$el)
    }

    destroy() {
        this.vueApp?.unmount()
    }
}
